import React, { useState } from 'react'
import { Form, Spin, Row, Col, Button, Divider } from 'antd'
import ds from '../../Services/DataServices'
import { useSelector, useDispatch } from 'react-redux'
import IntlMessages from '../../util/IntlMessages'
import { useHistory } from 'react-router-dom'
import { FormOutlined, PlusCircleOutlined } from '@ant-design/icons'
import SetupInventoryPic from '../../../src/assets/images/inventory-boxes.png'
import ReturningCustomerPic from '../../../src/assets/images/customers.png'
import GiftCardsPic from '../../../src/assets/images/GiftCards.png'
import LoyaltyRedemptionPic from '../../../src/assets/images/Rewardloyalcustomers.png'
import RetailMeasuresModal from './RetailMeasuresModal'
import { setCommonConfigs } from '../../appRedux/actions/CommonData'
import {
  isEmptyObject,
  checkRightspermissions,
  getDecryptID
} from '../../appRedux/actions/GlobalMethods'
import {
  loadRetailMeasuresModalShow,
  loadRetailMetricsMeasureData
} from '../../appRedux/actions/Reports'
import ReportLinks from './ReportLinks'
import PerformanceCardSection from './PerformanceCardSection'
import PerformanceTabSection from './PerformanceTabSection'
import GeneralCard from './GeneralCard'
import FilterSection from './FilterSection'
import { HOME } from '../../constants/Pages'
import { Period } from '../../constants/Period'
import { ReportMeasures, RetailMetricsMeasures, SectionEnums } from '../../constants/ReportMeasures'
// import { REACT_APP_BUS_SITE } from '../../constants/StoreSetting'
import { env } from '../../env'

const { REACT_APP_BUS_NAME, REACT_APP_BUS_SITE } = env
const style = {
  textDecoration: 'underline',
  padding: '0 0 10px 0',
  cursor: 'pointer'
}

const ReportTypes = {
  Products: 41,
  SalesSummary: 33,
  Users: 34,
  Tag: 46,
  PaymentType: 49
}

const ProductReportsLinksData = [
  {
    Key: 1,
    Name: 'dashboard.dashboardreporting.popularproducts',
    ReportTypeID: ReportTypes.Products,
    MeasureID: ReportMeasures.ItemSold,
    ReportName: 'salesreports',
    ReportID: 1
  },
  {
    Key: 2,
    Name: 'dashboard.dashboardreporting.productsalesbyuser',
    ReportTypeID: ReportTypes.Products,
    MeasureID: ReportMeasures.ItemSold,
    ReportName: 'salesreports',
    ReportID: 1
  },
  {
    Key: 3,
    Name: 'dashboard.dashboardreporting.productsalesbytype',
    ReportTypeID: ReportTypes.Products,
    MeasureID: ReportMeasures.ItemSold,
    ReportName: 'salesreports',
    ReportID: 1
  },
  {
    Key: 4,
    Name: 'dashboard.dashboardreporting.productsalesbycustomer',
    ReportTypeID: ReportTypes.Products,
    MeasureID: ReportMeasures.ItemSold,
    ReportName: 'salesreports',
    ReportID: 1
  },
  {
    Key: 5,
    Name: 'dashboard.dashboardreporting.productsalesbyoutlet',
    ReportTypeID: ReportTypes.Products,
    MeasureID: ReportMeasures.ItemSold,
    ReportName: 'salesreports',
    ReportID: 1
  },
  {
    Key: 6,
    Name: 'dashboard.dashboardreporting.productsalesbycustomergroup',
    ReportTypeID: ReportTypes.Products,
    MeasureID: ReportMeasures.ItemSold,
    ReportName: 'salesreports',
    ReportID: 1
  },
  {
    Key: 7,
    Name: 'dashboard.dashboardreporting.productsalesbysupplier',
    ReportTypeID: ReportTypes.Products,
    MeasureID: ReportMeasures.ItemSold,
    ReportName: 'salesreports',
    ReportID: 1
  }
]
const SalesReportsLinksData = [
  {
    Key: 1,
    Name: 'dashboard.dashboardreporting.salestotalbyperiod',
    ReportTypeID: ReportTypes.SalesSummary,
    MeasureID: ReportMeasures.Revenue,
    ReportID: 1,
    ReportName: 'salesreports'
  },
  {
    Key: 2,
    Name: 'dashboard.dashboardreporting.salestotalbymonth',
    ReportTypeID: ReportTypes.SalesSummary,
    MeasureID: ReportMeasures.Revenue,
    ReportID: 1,
    ReportName: 'salesreports'
  },
  {
    Key: 3,
    Name: 'dashboard.dashboardreporting.salestotalsbyday',
    ReportTypeID: ReportTypes.SalesSummary,
    MeasureID: ReportMeasures.Revenue,
    ReportID: 1,
    ReportName: 'salesreports'
  },
  {
    Key: 4,
    Name: 'dashboard.dashboardreporting.salesactivitybyhour',
    ReportTypeID: ReportTypes.SalesSummary,
    MeasureID: ReportMeasures.Revenue,
    ReportID: 1,
    ReportName: 'salesreports'
  },
  {
    Key: 5,
    Name: 'dashboard.dashboardreporting.salesbytag',
    ReportTypeID: ReportTypes.Tag,
    MeasureID: ReportMeasures.ItemSold,
    ReportID: 1,
    ReportName: 'salesreports'
  },
  {
    Key: 6,
    Name: 'dashboard.dashboardreporting.paymenttypesbymonth',
    ReportTypeID: ReportTypes.PaymentType,
    MeasureID: ReportMeasures.Amount,
    ReportID: 3,
    ReportName: 'paymentreports'
  }
]
const InventoryReportsLinksData = [
  {
    Key: 1,
    Name: 'dashboard.dashboardreporting.stocklevels',
    ReportTypeID: ReportTypes.Products,
    MeasureID: ReportMeasures.AllInventory,
    ReportID: 2,
    ReportName: 'inventoryreports'
  },
  {
    Key: 2,
    Name: 'dashboard.dashboardreporting.lowstock',
    ReportTypeID: ReportTypes.Products,
    MeasureID: ReportMeasures.LowInventory,
    ReportID: 2,
    ReportName: 'inventoryreports'
  },
  {
    Key: 3,
    Name: 'dashboard.dashboardreporting.stockonhand',
    ReportTypeID: ReportTypes.Products,
    MeasureID: ReportMeasures.OnHandInventory,
    ReportID: 2,
    ReportName: 'inventoryreports'
  },
  {
    Key: 4,
    Name: 'dashboard.dashboardreporting.productperformance',
    ReportTypeID: ReportTypes.Products,
    MeasureID: ReportMeasures.AllInventory,
    ReportID: 2,
    ReportName: 'inventoryreports'
  }
]
const DashboardSections = {
  OutletSaleSection: 1,
  SalesTargetSection: 2,
  MeasureSection: 3
}
const TopReportProductTypes = [
  {
    Key: 0,
    TopReportID: 0,
    Name: 'TopProductByQTY',
    DisplayName: 'dashboard.dashboardreporting.byquantity',
    MeasureID: ReportMeasures.ItemSold,
    ReportTypeID: ReportTypes.Products
  },
  {
    Key: 1,
    TopReportID: 1,
    Name: 'TopProductByRevenue',
    DisplayName: 'dashboard.dashboardreporting.byrevenue',
    MeasureID: ReportMeasures.Revenue,
    ReportTypeID: ReportTypes.Products
  }
]
const TopReportUserTypes = [
  {
    Key: 0,
    TopReportID: 2,
    Name: 'TopUsersByRevenue',
    DisplayName: 'dashboard.dashboardreporting.topsalespeople',
    MeasureID: ReportMeasures.Revenue,
    ReportTypeID: ReportTypes.Users
  }
]

const DashboardReporting = ({ match }) => {
  const dispatch = useDispatch()
  const [form] = Form.useForm()
  const history = useHistory()

  //#region useSelector

  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  )

  const getReduxRetailMetricsMeausureData = useSelector(
    ({ Reports }) => Reports.retailMetricsMeasureData
  )
  const getReduxDashboardSearchData = useSelector(
    ({ Reports }) => Reports.dashboardSearchData
  )
  const getReduxStoreOutlets = useSelector(
    ({ Sell }) => Sell.openCloseStoreOutlets
  )
  //#endregion

  //#region UseState
  const [getCurrData, setCurrData] = React.useState({
    currencyCode: '',
    currencyName: '',
    currencySymbol: ''
  })
  const [getIsDisableCreate, setIsDisableCreate] = useState(true)
  const [getIsDisableUpdate, setIsDisableUpdate] = useState(true)
  const [getIsDisableDelete, setIsDisableDelete] = useState(true)
  const [getIsAllowRead, setIsAllowRead] = useState(false)
  const [getAccessLoading, setAccessLoading] = useState(true)
  const [getRights, setRights] = useState([])
  const [getPermissions, setPermissions] = useState([])
  const [getPeriodName, setPeriodName] = React.useState('Day')
  const [getOutletName, setOutletName] = React.useState('ALL Outlets')

  //#endregion UseState

  //#region useEffect
  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      if (localStorage.getItem('RetailMetricsMeasures')) {
        const data = JSON.parse(localStorage.getItem('RetailMetricsMeasures'))
        dispatch(loadRetailMetricsMeasureData(data))
      } else {
        dispatch(loadRetailMetricsMeasureData(RetailMetricsMeasures))
      }
    }
    return () => {
      mounted = false
    }
  }, [])

  //for common data -> store currency
  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      const commonData = getReduxCommonSetting
      const respData =
        commonData &&
        commonData.storeCommonConfigs &&
        commonData.storeCommonConfigs.storeConfig
          ? commonData.storeCommonConfigs.storeConfig
          : {}
      if (respData && respData.currencyData) {
        let currencyData = respData.currencyData
        setCurrData(currencyData)
      }
      // rights && permissions
      if (commonData && commonData.storeCommonConfigs) {
        const rpData = checkRightspermissions(commonData)
        if (rpData && !isEmptyObject(rpData)) {
          setupRightsPermissions(rpData)
          setAccessLoading(false)
        } else {
          toInitialState()
          setAccessLoading(false)
        }
      }
    }

    return () => (mounted = false)
  }, [getReduxCommonSetting])

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      let outletName =
        getReduxStoreOutlets &&
        getReduxStoreOutlets.filter(
          x => getDecryptID(x.id) == getReduxDashboardSearchData.OutletID
        ) &&
        getReduxStoreOutlets.filter(
          x => getDecryptID(x.id) == getReduxDashboardSearchData.OutletID
        )[0]
          ? getReduxStoreOutlets.filter(
              x => getDecryptID(x.id) == getReduxDashboardSearchData.OutletID
            )[0].outlet
          : 'ALL Outlets'
      setOutletName(outletName)
    }

    return () => {
      mounted = false
    }
  }, [getReduxDashboardSearchData.OutletID])

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      let periodName = 'Day'
      const periodID = getReduxDashboardSearchData.PeriodID

      if (periodID == Period.Day) {
        periodName = 'Day'
      }

      if (periodID == Period.Week) {
        periodName = 'Week'
      }
      if (periodID == Period.Month) {
        periodName = 'Month'
      }
      setPeriodName(periodName)
    }

    return () => {
      mounted = false
    }
  }, [getReduxDashboardSearchData.PeriodID])

  //#endregion useEffect

  function setupRightsPermissions (rpData) {
    if (rpData.rights && rpData.rights.length > 0) {
      setRights(rpData.rights)
    } else {
      setRights([])
    }
    if (rpData.permissions && rpData.permissions.length > 0) {
      setPermissions(rpData.permissions)
    } else {
      setPermissions([])
    }
    if (rpData.read) {
      setIsAllowRead(true)
    } else {
      setIsAllowRead(false)
    }
    if (rpData.create) {
      setIsDisableCreate(false)
    } else {
      setIsDisableCreate(true)
    }
    if (rpData.update) {
      setIsDisableUpdate(false)
    } else {
      setIsDisableUpdate(true)
    }
    if (rpData.delete) {
      setIsDisableDelete(false)
    } else {
      setIsDisableDelete(true)
    }
  }
  function toInitialState () {
    setRights([])
    setPermissions([])
    setIsAllowRead(false)
    setIsDisableCreate(true)
    setIsDisableUpdate(true)
    setIsDisableDelete(true)
    setAccessLoading(true)
  }

  return (
    <Spin tip={'Loading'} spinning={false} size='large'>
      
        <Row className='Welcome-row'>
        <RetailMeasuresModal />
        <FilterSection />
        <PerformanceCardSection
          sectionID={DashboardSections.OutletSaleSection}
          periodID={getReduxDashboardSearchData.PeriodID}
          outletID={getReduxDashboardSearchData.OutletID}
          chartTitle={getOutletName}
          design='FullWidth'
          subHeading1={
            <IntlMessages id='dashboard.dashboardreporting.averagesalevalue' />
          }
          subHeading2={
            <IntlMessages id='dashboard.dashboardreporting.averageitemspersale' />
          }
          parentClassName ="ant-col-md-12 ant-col-sm-24 ant-col-xs-24 store-sold-box"
        />
        </Row>

        <Row>
          <Col md={24} className='Things-to-know-box'>

            <Row className='d-flex align-items-center justify-content-between thingstoknow-btn'>
              <Col lg={12}>
              <h2>
                <IntlMessages id='dashboard.dashboardreporting.thingstoknow' />
              </h2>
              </Col>
              <Col lg={12} className='text-right'>
              <Button
              type="primary"
              size="large"
              className="mb-3"
               icon={<PlusCircleOutlined className='dk-btn-icon-align' />}
                onClick={() => {
                  dispatch(loadRetailMeasuresModalShow(true))
                }}
              >
                <IntlMessages id='dashboard.dashboardreporting.showmoreretail' />
              </Button>
              </Col>
            </Row>

            <PerformanceCardSection
              sectionID={DashboardSections.SalesTargetSection}
              periodID={getReduxDashboardSearchData.PeriodID}
              outletID={getReduxDashboardSearchData.OutletID}
              chartTitle={
                <>
                  <span>
                    <IntlMessages id='dashboard.dashboardreporting.yoursalesthis' />
                  </span>{' '}
                  &nbsp;
                  {getPeriodName}
                </>
              }
              showProgressSection={true}
              design='Compact'
              parentClassName="sales-target-box div-flow"
            />
            <Row className='ProductsSold-row'>
              <Col xl={16} lg={12} md={12} sm={24} xs={24}>
                <PerformanceTabSection
                  periodID={getReduxDashboardSearchData.PeriodID}
                  outletID={getReduxDashboardSearchData.OutletID}
                  topReportProductTypes={TopReportProductTypes}
                  mainTitle={'dashboard.dashboardreporting.topproductssold'}
                />
              </Col>
              <Col xl={8} lg={12} md={12} sm={24} xs={24}>
                <GeneralCard
                  ImageIcon={'d-block-center'}
                  Image={SetupInventoryPic}
                  Heading={
                    <IntlMessages id='dashboard.dashboardreporting.optimiseyourinventory' />
                  }
                  Content={
                    <IntlMessages id='dashboard.dashboardreporting.stockcontrolhelpsyou' />
                  }
                  Link={'/dashboard/inventory/stockcontrol/stockcontrollist'}
                  LinkText={
                    <IntlMessages id='dashboard.dashboardreporting.gotostockcontrol' />
                  }
                  LinkIcon={''}
                  NotButtonText={
                    <IntlMessages id='dashboard.dashboardreporting.notnow' />
                  }
                  IsNotButton={true}
                />
              </Col>
            </Row>

            <Row className='Dashboard-bottom-boxes'>
              <Col xl={8} lg={12} md={12} sm={24} xs={24}>
                <GeneralCard
                  ImageIcon={'d-block-center'}
                  Image={ReturningCustomerPic}
                  Heading={
                    <IntlMessages id='dashboard.dashboardreporting.findyourbest' />
                  }
                  Content={
                    <IntlMessages id='dashboard.dashboardreporting.learnhowto' />
                  }
                  Link={`${REACT_APP_BUS_SITE}`}
                  LinkText={
                    <IntlMessages id='dashboard.dashboardreporting.readaboutit' />
                  }
                  LinkIcon={<FormOutlined />}
                  NotButtonText={
                    <IntlMessages id='dashboard.dashboardreporting.notnow' />
                  }
                  IsNotButton={true}
                />
              </Col>
              <Col xl={8} lg={12} md={12} sm={24} xs={24}>
                <GeneralCard
                  ImageIcon={'d-block-center'}
                  Image={LoyaltyRedemptionPic}
                  Heading={
                    <IntlMessages id='dashboard.dashboardreporting.rewardloyalcustomer' />
                  }
                  Content={
                    <IntlMessages id='dashboard.dashboardreporting.switchonloyalty' />
                  }
                  Link={'/dashboard/Setup/Loyalty/main'}
                  LinkText={
                    <IntlMessages id='dashboard.dashboardreporting.findoutmore' />
                  }
                  LinkIcon={''}
                  NotButtonText={
                    <IntlMessages id='dashboard.dashboardreporting.notnow' />
                  }
                  IsNotButton={true}
                />
              </Col>
              <Col xl={8} lg={24} md={12} sm={24} xs={24}>
                <GeneralCard
                  ImageIcon={'d-block-center'}
                  Image={GiftCardsPic}
                  Heading={
                    <IntlMessages
                      id='dashboard.dashboardreporting.saleandtrack'
                      values={{
                        strong: chunks => <strong>{chunks}</strong>,
                        bus_name_first: REACT_APP_BUS_NAME
                      }}
                    />
                  }
                  Content={
                    <IntlMessages id='dashboard.dashboardreporting.giveshoppersa' />
                  }
                  Link={''}
                  LinkText={
                    <IntlMessages id='dashboard.dashboardreporting.comingsoon' />
                  }
                  LinkIcon={''}
                  NotButtonText={
                    <IntlMessages id='dashboard.dashboardreporting.notnow' />
                  }
                  IsNotButton={true}
                  IsButtonDisable={true}
                />
              </Col>

              {getReduxRetailMetricsMeausureData &&
              getReduxRetailMetricsMeausureData.filter(
                x => x.Key == SectionEnums.Revenue
              )[0] &&
              getReduxRetailMetricsMeausureData.filter(
                x => x.Key == SectionEnums.Revenue
              )[0].IsSelected ? (
                <Col xl={8} lg={12} md={12} sm={24} xs={24}>
                  <PerformanceCardSection
                    cardTitle={
                      <IntlMessages id='reporting.retaildashboard.revenue' />
                    }
                    sectionID={DashboardSections.MeasureSection}
                    periodID={getReduxDashboardSearchData.PeriodID}
                    outletID={getReduxDashboardSearchData.OutletID}
                    measureID={ReportMeasures.Revenue}
                    design='MeasureDesign'
                    reportTypeID={ReportTypes.Products}
                    isCurrencyMeasure={true}
                  />
                </Col>
              ) : (
                ''
              )}
              {getReduxRetailMetricsMeausureData &&
              getReduxRetailMetricsMeausureData.filter(
                x => x.Key == SectionEnums.GrossProfit
              )[0] &&
              getReduxRetailMetricsMeausureData.filter(
                x => x.Key == SectionEnums.GrossProfit
              )[0].IsSelected ? (
                <Col xl={8} lg={12} md={12} sm={24} xs={24}>
                  <PerformanceCardSection
                    cardTitle={
                      <IntlMessages id='reporting.retaildashboard.grossprofit' />
                    }
                    sectionID={DashboardSections.MeasureSection}
                    periodID={getReduxDashboardSearchData.PeriodID}
                    outletID={getReduxDashboardSearchData.OutletID}
                    measureID={ReportMeasures.GrossProfit}
                    design='MeasureDesign'
                    reportTypeID={ReportTypes.SalesSummary}
                    isCurrencyMeasure={true}
                  />
                </Col>
              ) : (
                ''
              )}

              {getReduxRetailMetricsMeausureData &&
              getReduxRetailMetricsMeausureData.filter(
                x => x.Key == SectionEnums.SaleCount
              )[0] &&
              getReduxRetailMetricsMeausureData.filter(
                x => x.Key == SectionEnums.SaleCount
              )[0].IsSelected ? (
                <Col xl={8} lg={12} md={12} sm={24} xs={24}>
                  <PerformanceCardSection
                    cardTitle={
                      <IntlMessages id='reporting.retaildashboard.salecount' />
                    }
                    sectionID={DashboardSections.MeasureSection}
                    periodID={getReduxDashboardSearchData.PeriodID}
                    outletID={getReduxDashboardSearchData.OutletID}
                    measureID={ReportMeasures.SaleCount}
                    design='MeasureDesign'
                    reportTypeID={ReportTypes.SalesSummary}
                    isCurrencyMeasure={true}
                  />
                </Col>
              ) : (
                ''
              )}

{getReduxRetailMetricsMeausureData &&
              getReduxRetailMetricsMeausureData.filter(
                x => x.Key == SectionEnums.AvgSaleValue
              )[0] &&
              getReduxRetailMetricsMeausureData.filter(
                x => x.Key == SectionEnums.AvgSaleValue
              )[0].IsSelected ? (
                <Col xl={8} lg={12} md={12} sm={24} xs={24}>
                  <PerformanceCardSection
                    cardTitle={
                      <IntlMessages id='reporting.retaildashboard.avgsalevalue' />
                    }
                    sectionID={DashboardSections.MeasureSection}
                    periodID={getReduxDashboardSearchData.PeriodID}
                    outletID={getReduxDashboardSearchData.OutletID}
                    measureID={ReportMeasures.AvgSaleValue}
                    design='MeasureDesign'
                    reportTypeID={ReportTypes.SalesSummary}
                    isCurrencyMeasure={true}
                  />
                </Col>
              ) : (
                ''
              )}

              {getReduxRetailMetricsMeausureData &&
              getReduxRetailMetricsMeausureData.filter(
                x => x.Key == SectionEnums.AvgItemPerSale
              )[0] &&
              getReduxRetailMetricsMeausureData.filter(
                x => x.Key == SectionEnums.AvgItemPerSale
              )[0].IsSelected ? (
                <Col xl={8} lg={12} md={12} sm={24} xs={24}>
                  <PerformanceCardSection
                    cardTitle={
                      <IntlMessages id='reporting.retaildashboard.avgitemspersale' />
                    }
                    sectionID={DashboardSections.MeasureSection}
                    periodID={getReduxDashboardSearchData.PeriodID}
                    outletID={getReduxDashboardSearchData.OutletID}
                    measureID={ReportMeasures.AvgItemperSale}
                    design='MeasureDesign'
                    reportTypeID={ReportTypes.SalesSummary}
                    isCurrencyMeasure={true}
                  />
                </Col>
              ) : (
                ''
              )}

              {getReduxRetailMetricsMeausureData &&
              getReduxRetailMetricsMeausureData.filter(
                x => x.Key == SectionEnums.SalesWithCustomer
              )[0] &&
              getReduxRetailMetricsMeausureData.filter(
                x => x.Key == SectionEnums.SalesWithCustomer
              )[0].IsSelected ? (
                <Col xl={8} lg={12} md={12} sm={24} xs={24}>
                  <PerformanceCardSection
                    cardTitle={
                      <IntlMessages id='reporting.retaildashboard.saleswithcustomercard' />
                    }
                    sectionID={DashboardSections.MeasureSection}
                    periodID={getReduxDashboardSearchData.PeriodID}
                    outletID={getReduxDashboardSearchData.OutletID}
                    measureID={ReportMeasures.SaleswithCustomerPercentage}
                    design='MeasureDesign'
                    reportTypeID={ReportTypes.SalesSummary}
                    isCurrencyMeasure={true}
                  />
                </Col>
              ) : (
                ''
              )}
              {getReduxRetailMetricsMeausureData &&
              getReduxRetailMetricsMeausureData.filter(
                x => x.Key == SectionEnums.TopSalesPeople
              )[0] &&
              getReduxRetailMetricsMeausureData.filter(
                x => x.Key == SectionEnums.TopSalesPeople
              )[0].IsSelected ? (
                <Col xl={16} lg={12} md={12} sm={24} xs={24}>
                  <PerformanceTabSection
                    periodID={getReduxDashboardSearchData.PeriodID}
                    outletID={getReduxDashboardSearchData.OutletID}
                    topReportProductTypes={TopReportUserTypes}
                    mainTitle={'dashboard.dashboardreporting.topsalespeople'}
                  />
                </Col>
              ) : (
                ''
              )}
              {getReduxRetailMetricsMeausureData &&
              getReduxRetailMetricsMeausureData.filter(
                x => x.Key == SectionEnums.Discounted
              )[0] &&
              getReduxRetailMetricsMeausureData.filter(
                x => x.Key == SectionEnums.Discounted
              )[0].IsSelected ? (
                <Col xl={8} lg={12} md={24} sm={24} xs={24}>
                  <PerformanceCardSection
                    cardTitle={
                      <IntlMessages id='reporting.retaildashboard.discounted' />
                    }
                    sectionID={DashboardSections.MeasureSection}
                    periodID={getReduxDashboardSearchData.PeriodID}
                    outletID={getReduxDashboardSearchData.OutletID}
                    measureID={ReportMeasures.Discounted}
                    design='LeftCompactDesign'
                    reportTypeID={ReportTypes.SalesSummary}
                    isCurrencyMeasure={false}
                    subHeading1={
                      <IntlMessages
                        id={'reporting.retaildashboard.totaldiscounted'}
                      />
                    }
                    subHeading2={
                      <IntlMessages
                        id={
                          'reporting.retaildashboard.totaldiscountedpercentage'
                        }
                      />
                    }
                  />
                </Col>
              ) : (
                ''
              )}
            </Row>
           
          </Col>
         
        </Row>

        <Row className='Dashboard-Footer'>

          <Col xl={5} lg={8} md={8} sm={12} xs={24}>
            <ReportLinks
              periodID={getReduxDashboardSearchData.PeriodID}
              title={
                <IntlMessages id='dashboard.dashboardreporting.productreports' />
              }
              data={ProductReportsLinksData}
            />
          </Col>

          <Col xl={5} lg={8} md={8} sm={12} xs={24}>
            <ReportLinks
              periodID={getReduxDashboardSearchData.PeriodID}
              title={
                <IntlMessages id='dashboard.dashboardreporting.salesreport' />
              }
              data={SalesReportsLinksData}
            />
          </Col>

          <Col xl={5} lg={8} md={8} sm={12} xs={24}>
            <ReportLinks
              periodID={getReduxDashboardSearchData.PeriodID}
              title={
                <IntlMessages id='dashboard.dashboardreporting.inventoryreports' />
              }
              data={InventoryReportsLinksData}
            />
          </Col>

          <Col xl={5} lg={8} md={8} sm={12} xs={24}>
            <h3 className='RegisterReports'>
              {' '}
              <IntlMessages id='dashboard.dashboardreporting.registereports' />
            </h3>
            <Divider />
            <ul className="Dashboard-Footer-ul">
              <li>
            <div onClick={() => { history.push('/dashboard/reporting/registerclosures/listing') }} >
              <IntlMessages id='dashboard.dashboardreporting.registerclousures' />
            </div>
            </li>
            </ul>
          </Col>

          <Col xl={4} lg={8} md={8} sm={24} xs={24}>
            <h3 className='OtherReports'>
              {' '}
              <IntlMessages id='dashboard.dashboardreporting.otherreports' />
            </h3>
            <Divider />
            <ul className="Dashboard-Footer-ul">
              <li>
            <div onClick={() => { history.push('/dashboard/reporting/store_credit') }} >
              <IntlMessages id='dashboard.dashboardreporting.storecredit' />
            </div>
            </li>
            </ul>
          </Col>

        </Row>

        
    </Spin>
  )
}

export default DashboardReporting
